<div class="footer">
  <div class="content">
    <div class="section">
      <span class="disclaimer">INTERNAL USE ONLY</span>
    </div>
  </div>
</div>
